"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _Text = _interopRequireDefault(require("../Text"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Link = _interopRequireDefault(require("../Link"));
var _GtmContext = require("@airasia/phoenix-common/common/GtmContext");
var _constant = require("../constant");
var _utilities = _interopRequireDefault(require("../../utilities"));
var _constant2 = require("../JourneyPriceCTA/constant");
var _NotificationBannerInline = _interopRequireDefault(require("./NotificationBannerInline.proptypes"));
var _constant3 = require("./constant");
var _FomoIcon = _interopRequireDefault(require("./FomoIcon"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable react/prop-types */

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "NotificationBannerInline__Wrapper",
  componentId: "sc-bym33f-0"
})(["width:", ";background:", ";", " box-sizing:border-box;", " border-radius:", ";display:flex;padding-top:", ";padding-right:", ";padding-bottom:", ";padding-left:", ";flex:1;cursor:pointer;overflow:hidden;display:", ";"], function (_ref) {
  var fullWidth = _ref.fullWidth;
  return fullWidth ? '100%' : 'fit-content';
}, function (_ref2) {
  var theme = _ref2.theme,
    schema = _ref2.schema,
    backgroundColor = _ref2.backgroundColor;
  return theme.backgroundColor[backgroundColor] || theme.backgroundColor[schema.backgroundColor];
}, function (_ref3) {
  var border = _ref3.border;
  return border ? (0, _styledComponents.css)(["border:1px solid ", ";"], function (_ref4) {
    var theme = _ref4.theme,
      schema = _ref4.schema,
      borderColor = _ref4.borderColor;
    return theme.colors[borderColor] || theme.colors[schema.borderColor];
  }) : (0, _styledComponents.css)(["border:'none';"]);
}, function (_ref5) {
  var hasBoxShadow = _ref5.hasBoxShadow;
  return hasBoxShadow ? "box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);" : '';
}, function (_ref6) {
  var theme = _ref6.theme,
    borderRadius = _ref6.borderRadius;
  return borderRadius ? theme.borderRadius[borderRadius] : theme.borderRadius.small;
}, function (_ref7) {
  var theme = _ref7.theme,
    largerPadding = _ref7.largerPadding;
  return largerPadding ? theme.space.medium : theme.space.tiny;
}, function (_ref8) {
  var theme = _ref8.theme,
    smallerPadding = _ref8.smallerPadding;
  return smallerPadding ? theme.space.tiny : theme.space.small;
}, function (_ref9) {
  var theme = _ref9.theme,
    largerPadding = _ref9.largerPadding;
  return largerPadding ? theme.space.medium : theme.space.tiny;
}, function (_ref10) {
  var theme = _ref10.theme,
    smallerPadding = _ref10.smallerPadding;
  return smallerPadding ? theme.space.tiny : theme.space.small;
}, function (_ref11) {
  var isVisible = _ref11.isVisible;
  return isVisible ? 'flex' : 'none';
});
var Message = _styledComponents.default.div.withConfig({
  displayName: "NotificationBannerInline__Message",
  componentId: "sc-bym33f-1"
})(["display:block;margin:0;"]);
var LeftIcon = _styledComponents.default.div.withConfig({
  displayName: "NotificationBannerInline__LeftIcon",
  componentId: "sc-bym33f-2"
})(["position:relative;display:flex;margin-right:", ";max-width:24px;max-height:24px;", ""], function (_ref12) {
  var theme = _ref12.theme;
  return theme.space.micro;
}, function (_ref13) {
  var hasBadge = _ref13.hasBadge;
  return hasBadge && (0, _styledComponents.css)(["margin-top:", ";"], function (_ref14) {
    var theme = _ref14.theme;
    return theme.space.micro;
  });
});
var RightIcon = _styledComponents.default.div.withConfig({
  displayName: "NotificationBannerInline__RightIcon",
  componentId: "sc-bym33f-3"
})(["display:flex;cursor:pointer;padding-left:", ";"], function (_ref15) {
  var theme = _ref15.theme;
  return theme.space.small;
});
var Badge = _styledComponents.default.span.withConfig({
  displayName: "NotificationBannerInline__Badge",
  componentId: "sc-bym33f-4"
})(["position:absolute;top:-7px;right:-7px;border-radius:50%;font-family:", ";background-color:", ";color:", ";font-size:", ";padding:", " ", ";"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.fontFamily.default;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.primary;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.colors.default;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontSize.XSmall;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.space.micro;
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.space.tiny;
});
var MultipleMessageContainer = _styledComponents.default.div.withConfig({
  displayName: "NotificationBannerInline__MultipleMessageContainer",
  componentId: "sc-bym33f-5"
})(["padding-left:", ";min-height:30px;& > *{display:block;}&.animate{-webkit-animation:goupdown 0.8s infinite;-moz-animation:goupdown 0.8s infinite;-o-animation:goupdown 0.8s infinite;animation:goupdown 0.8s infinite ease-in-out;}@keyframes goupdown{0%{opacity:1;transition:translateY(0px);}10%{opacity:0.8;transition:translateY(-3px);}20%{opacity:0.5;transition:translateY(-5px);}30%{opacity:0.3;transition:translateY(-8px);}40%{opacity:0.2;transform:translateY(-10px);}50%{opacity:0;transform:translateY(-15px);}70%{opacity:0;transform:translateY(20px);}80%{opacity:0.2;transform:translateY(15px);}85%{opacity:0.3;transform:translateY(12px);}90%{opacity:0.5;transform:translateY(9px);}95%{opacity:0.5;transform:translateY(4px);}100%{opacity:1;transform:translateY(0px);}}"], function (_ref22) {
  var theme = _ref22.theme;
  return theme.space.tiny;
});
var NotificationWindow = _styledComponents.default.div.withConfig({
  displayName: "NotificationBannerInline__NotificationWindow",
  componentId: "sc-bym33f-6"
})(["position:fixed;top:0;bottom:0;right:-100%;width:35vw;min-width:450px;z-index:20;overflow:auto;background-color:", ";padding:", ";transition:0.3s ease-out;&.open{right:0;}", ""], function (_ref23) {
  var theme = _ref23.theme;
  return theme.colors.default;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.space.small;
}, function (_ref25) {
  var isMobile = _ref25.isMobile;
  return isMobile && (0, _styledComponents.css)(["width:calc(100% - ", " * 2);min-width:unset;"], function (_ref26) {
    var theme = _ref26.theme;
    return theme.space.small;
  });
});
var NotifOverlay = _styledComponents.default.div.withConfig({
  displayName: "NotificationBannerInline__NotifOverlay",
  componentId: "sc-bym33f-7"
})(["position:fixed;top:0;bottom:0;left:0;right:0;z-index:-1;background-color:", ";opacity:0;transition:ease-out 0.3s;&.open{z-index:19;opacity:0.5;}"], function (_ref27) {
  var theme = _ref27.theme;
  return theme.colors.greyDarker;
});
var NotifCloseBtn = _styledComponents.default.div.withConfig({
  displayName: "NotificationBannerInline__NotifCloseBtn",
  componentId: "sc-bym33f-8"
})(["float:right;margin-bottom:", ";cursor:pointer;"], function (_ref28) {
  var theme = _ref28.theme;
  return theme.space.normal;
});
var NotifItem = _styledComponents.default.div.withConfig({
  displayName: "NotificationBannerInline__NotifItem",
  componentId: "sc-bym33f-9"
})(["margin-bottom:", ";"], function (_ref29) {
  var theme = _ref29.theme;
  return theme.space.small;
});
var HiddenBanner = _styledComponents.default.div.withConfig({
  displayName: "NotificationBannerInline__HiddenBanner",
  componentId: "sc-bym33f-10"
})(["display:block;padding-left:", ";font-family:", ";"], function (_ref30) {
  var theme = _ref30.theme;
  return theme.space.tiny;
}, function (_ref31) {
  var theme = _ref31.theme;
  return theme.fontFamily.default;
});
var NotificationBannerInline = function NotificationBannerInline(_ref32) {
  var customProperties = _ref32.customProperties,
    accessible = _ref32.accessible,
    message = _ref32.message,
    closable = _ref32.closable,
    type = _ref32.type,
    theme = _ref32.theme,
    showLeftIcon = _ref32.showLeftIcon,
    fullWidth = _ref32.fullWidth,
    timer = _ref32.timer,
    textType = _ref32.textType,
    border = _ref32.border,
    borderRadius = _ref32.borderRadius,
    otherNotificationLabel = _ref32.otherNotificationLabel,
    device = _ref32.device,
    customIcon = _ref32.customIcon,
    smallerPadding = _ref32.smallerPadding,
    idconfig = _ref32.idconfig,
    ctaColor = _ref32.ctaColor,
    ctaSize = _ref32.ctaSize,
    isBannerClickable = _ref32.isBannerClickable,
    hasBoxShadow = _ref32.hasBoxShadow,
    largerPadding = _ref32.largerPadding,
    iconName = _ref32.iconName,
    backgroundColor = _ref32.backgroundColor,
    borderColor = _ref32.borderColor,
    textColor = _ref32.textColor,
    iconColor = _ref32.iconColor,
    fireGtm = _ref32.fireGtm,
    gtmErrorObj = _ref32.gtmErrorObj,
    notificationTimeout = _ref32.notificationTimeout;
  var _ref33 = idconfig || {},
    widgetName = _ref33.widgetName,
    parentName = _ref33.parentName;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var isMultipleMessages = Array.isArray(message);
  var isMessageArrayLengthGreaterThanOne = isMultipleMessages && message.length > 1;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    animate = _useState4[0],
    setAnimate = _useState4[1];
  var _useState5 = (0, _react.useState)(isMultipleMessages ? message[index] : message),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    currentMessage = _useState6[0],
    setCurrentMessage = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
    showNotifWindow = _useState8[0],
    setShowNotifWindow = _useState8[1];
  var _useState9 = (0, _react.useState)(true),
    _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
    showHiddenDiv = _useState10[0],
    setShowHiddenDiv = _useState10[1];
  var _useState11 = (0, _react.useState)(true),
    _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
    isVisible = _useState12[0],
    setIsVisible = _useState12[1];
  var schema = _constant3.ColorSchema[type];
  var notificationBannerRef = (0, _react.useRef)(null);
  var hiddenNotificationBannerRef = (0, _react.useRef)(null);
  var hiddenCTARef = (0, _react.useRef)(null);
  var notifWindowRef = (0, _react.useRef)(null);
  var notifCloseBtnRef = (0, _react.useRef)(null);
  var gtmContext = (0, _GtmContext.useGtmContext)();
  (0, _react.useEffect)(function () {
    setCurrentMessage(isMultipleMessages ? message[index] : message);
  }, [index, isMultipleMessages, message]);
  var _useState13 = (0, _react.useState)('notificationBannerInline'),
    _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
    dynamicID = _useState14[0],
    setId = _useState14[1];
  (0, _react.useEffect)(function () {
    var url = 'notificationBannerInline';
    if (parentName) {
      url = "".concat(parentName, "-notificationBannerInline");
    }
    if (index) {
      url += "-".concat(index);
    }
    if (widgetName) {
      url = "".concat(widgetName, "-").concat(url);
    }
    setId(url);
  }, [widgetName, parentName, index]);
  var transformString = function transformString(inputString, args) {
    return inputString.replace(/{(\d+)}/g, function (match, number) {
      return typeof args[number] !== 'undefined' ? args[number] : match;
    });
  };
  var otherNotifLabel = isMultipleMessages && transformString(otherNotificationLabel, [(message === null || message === void 0 ? void 0 : message.length) - 1]);
  var removeAnimate = function removeAnimate() {
    return setTimeout(function () {
      setAnimate(false);
    }, 400);
  };
  (0, _react.useEffect)(function () {
    var removeAnimateClass = removeAnimate();
    return function () {
      return clearTimeout(removeAnimateClass);
    };
  }, [index]);
  (0, _react.useEffect)(function () {
    if (fireGtm) {
      var gtmObj = _utilities.default.createGTMObject(gtmErrorObj, gtmContext);
      fireGtm(gtmObj);
    }
  }, [fireGtm, gtmErrorObj, gtmContext]);
  (0, _react.useEffect)(function () {
    if (!isMultipleMessages || showNotifWindow || !isMessageArrayLengthGreaterThanOne) {
      return undefined;
    }
    var nextMessage = setTimeout(function () {
      if (animate) {
        var newIndex = index + 1;
        if (newIndex > message.length - 1) {
          newIndex = 0;
        }
        setIndex(newIndex);
        setCurrentMessage(message[newIndex]);
      }
    }, 400);
    var messageLoop = setTimeout(function () {
      setAnimate(true);
    }, timer);
    return function () {
      clearTimeout(messageLoop);
      clearTimeout(nextMessage);
    };
  });
  (0, _react.useEffect)(function () {
    if (!notificationTimeout) return undefined;
    var hideNotification = setTimeout(function () {
      setIsVisible(false);
    }, notificationTimeout);
    return function () {
      clearTimeout(hideNotification);
    };
  });
  var seeMore = function seeMore(e) {
    if (!isMultipleMessages) {
      return;
    }
    if (!isBannerClickable) {
      return;
    }
    if (!e.target.href && isMessageArrayLengthGreaterThanOne) {
      setShowNotifWindow(true);
      removeAnimate();
    }
    if (!isMessageArrayLengthGreaterThanOne && currentMessage.cta && currentMessage.url || showNotifWindow) {
      if (typeof window !== 'undefined') {
        var openType = currentMessage.newTab.toLowerCase() === 'false' ? '_parent' : '_blank';
        window.open(currentMessage.url, openType);
      }
    }
  };
  var closeNotifWindow = function closeNotifWindow() {
    setShowNotifWindow(false);
  };
  var computeNotificationHeight = function computeNotificationHeight() {
    if (isMultipleMessages && isMessageArrayLengthGreaterThanOne) {
      setShowHiddenDiv(true);
      var highestHeight = 0;
      var combinedHeight = 0;
      message.forEach(function (msg) {
        hiddenNotificationBannerRef.current.innerHTML = msg.text;
        if (msg.cta) {
          hiddenCTARef.current.innerText = msg.cta;
        }
        combinedHeight = hiddenNotificationBannerRef.current.offsetHeight + hiddenCTARef.current.offsetHeight;
        highestHeight = combinedHeight > highestHeight ? combinedHeight : highestHeight;
      });
      if (document.getElementById('notificationSlide')) {
        document.getElementById('notificationSlide').style.height = "".concat(highestHeight, "px");
      }
      setShowHiddenDiv(false);
    }
  };
  (0, _react.useEffect)(function () {
    computeNotificationHeight();
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', computeNotificationHeight);
    }
    return function () {
      return typeof window !== 'undefined' ? window.removeEventListener('resize', computeNotificationHeight) : null;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  var wrapperKeyDownHandler = function wrapperKeyDownHandler(e) {
    seeMore(e);
    notifWindowRef.current.focus();
  };
  var move = theme === _constant2.THEMES.MOVE;
  var getMain = function getMain(messageInfo) {
    var showBadge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var notWindow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var isAccessible = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var tabIndex = !accessible || !isAccessible ? '-1' : '0';
    var isCTAAccessible = Boolean(notWindow && isAccessible);
    return /*#__PURE__*/_react.default.createElement(Wrapper, (0, _extends2.default)({
      id: dynamicID
    }, customProperties, {
      tabIndex: tabIndex,
      theme: themeContext,
      schema: schema,
      fullWidth: fullWidth,
      onClick: seeMore,
      onKeyDown: function onKeyDown(e) {
        return _utilities.default.keyDownHandler(e, function () {
          return wrapperKeyDownHandler(e);
        }, _constant.KEY_CODE.ENTER);
      },
      border: border,
      borderRadius: borderRadius,
      "aria-live": "off",
      ref: notificationBannerRef,
      "aria-label": "".concat(isMultipleMessages ? messageInfo.text : messageInfo, ". ").concat(messageInfo.cta, ". Actionable Left click or press enter to proceed."),
      smallerPadding: smallerPadding,
      style: {
        cursor: !isBannerClickable && 'default'
      },
      hasBoxShadow: hasBoxShadow,
      largerPadding: largerPadding,
      isVisible: isVisible,
      backgroundColor: backgroundColor,
      textColor: textColor,
      borderColor: borderColor
    }), showLeftIcon && /*#__PURE__*/_react.default.createElement(LeftIcon, {
      theme: themeContext,
      hasBadge: isMultipleMessages && showBadge
    }, type === 'fomoWarning' ? /*#__PURE__*/_react.default.createElement(_FomoIcon.default, null) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: textColor || move && 'darkGrey' || schema.iconColor || schema.textColor,
      fontsize: "titleNormal",
      icon: iconName || customIcon || schema.iconName,
      accessible: false
    }), isMultipleMessages && isMessageArrayLengthGreaterThanOne && showBadge && /*#__PURE__*/_react.default.createElement(Badge, {
      theme: themeContext,
      "aria-hidden": "true"
    }, message === null || message === void 0 ? void 0 : message.length)), /*#__PURE__*/_react.default.createElement(Message, {
      id: "notificationSlide"
    }, isMultipleMessages ? /*#__PURE__*/_react.default.createElement(MultipleMessageContainer, {
      className: animate && 'animate'
    }, /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: false,
      type: move ? 'small' : textType,
      color: textColor || schema.textColor,
      fontSize: move ? '0.75rem' : '1rem'
    }, messageInfo.text), messageInfo.cta && !messageInfo.onClick ? /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: messageInfo.url,
      theme: themeContext,
      color: move ? 'tertiaryRed' : ctaColor,
      size: move ? 'XSmall' : ctaSize || undefined,
      paddingTop: move ? '4px' : '0px',
      target: messageInfo.newTab && messageInfo.newTab.toLowerCase() === 'false' ? 'parent' : undefined,
      accessible: isCTAAccessible,
      idconfig: {
        parentName: 'notificationBannerInline'
      }
    }, messageInfo.cta) : null, messageInfo.cta && !!messageInfo.onClick ? /*#__PURE__*/_react.default.createElement(_Link.default, {
      href: "javascript.void(0);",
      target: "callback",
      callback: messageInfo.onClick,
      type: "secured",
      theme: themeContext,
      color: move ? 'tertiaryRed' : ctaColor,
      size: move ? 'XSmall' : ctaSize || undefined,
      accessible: isCTAAccessible,
      idconfig: {
        parentName: 'notificationBannerInline'
      }
    }, messageInfo.cta) : null) : /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: false,
      type: move ? 'textSmall' : textType,
      color: iconColor && 'black' || textColor || (move ? 'oldPrimaryDark' : schema.textColor)
    }, messageInfo),
    // Empty divs that will help in fix height computation
    showHiddenDiv && notWindow && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(HiddenBanner, {
      ref: hiddenNotificationBannerRef
    }), /*#__PURE__*/_react.default.createElement(HiddenBanner, {
      ref: hiddenCTARef
    }))), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        flex: 1
      }
    }), closable && isVisible && /*#__PURE__*/_react.default.createElement(RightIcon, {
      id: dynamicID,
      onClick: function onClick() {
        return setIsVisible(false);
      },
      onKeyDown: function onKeyDown(e) {
        return _utilities.default.keyDownHandler(e, setIsVisible(false), _constant.KEY_CODE.ENTER);
      },
      theme: themeContext
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: schema.textColor,
      fontsize: "titleNormal",
      icon: "CloseIcon",
      accessible: accessible
    })));
  };
  var NotifWindow = function NotifWindow() {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(NotifOverlay, {
      id: dynamicID,
      onClick: closeNotifWindow,
      className: showNotifWindow && 'open'
    }), /*#__PURE__*/_react.default.createElement(NotificationWindow, {
      ref: notifWindowRef,
      onKeyDown: function onKeyDown(e) {
        return _utilities.default.keyDownHandler(e, closeNotifWindow, _constant.KEY_CODE.ESC);
      },
      onBlur: showNotifWindow ? function (e) {
        return _utilities.default.trapFocus(e, notifWindowRef, notifCloseBtnRef);
      } : null,
      tabIndex: showNotifWindow ? 0 : -1,
      isMobile: device === _constant.DEVICE_TYPE.MOBILE,
      className: showNotifWindow && 'open'
    }, /*#__PURE__*/_react.default.createElement(NotifCloseBtn, {
      id: dynamicID,
      ref: notifCloseBtnRef,
      tabIndex: showNotifWindow ? 0 : -1,
      onClick: closeNotifWindow,
      onKeyDown: function onKeyDown(e) {
        return _utilities.default.keyDownHandler(e, closeNotifWindow, _constant.KEY_CODE.ENTER);
      }
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      color: schema.textColor,
      fontsize: "titleNormal",
      icon: "CloseIcon",
      accessible: false
    })), /*#__PURE__*/_react.default.createElement(NotifItem, null, getMain(currentMessage, false, false, showNotifWindow)), /*#__PURE__*/_react.default.createElement(_Text.default, {
      accessible: showNotifWindow && accessible,
      type: move ? 'small' : textType,
      color: schema.textColor,
      fontSize: move ? '0.75rem' : '1rem',
      marginBottom: "small"
    }, otherNotifLabel), message === null || message === void 0 ? void 0 : message.map(function (msg, idx) {
      if (idx === index) {
        return undefined;
      }
      // eslint-disable-next-line react/no-array-index-key
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _react.default.createElement(NotifItem, {
          key: "notif-".concat(idx)
        }, getMain(msg, false, false, showNotifWindow))
      );
    })));
  };
  return themeContext ? isMultipleMessages && getMain(currentMessage) || getMain(message) : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain(currentMessage), isMultipleMessages && isMessageArrayLengthGreaterThanOne && NotifWindow());
};
NotificationBannerInline.propTypes = _NotificationBannerInline.default.PropTypes;
NotificationBannerInline.defaultProps = _NotificationBannerInline.default.DefaultProps;
var _default = NotificationBannerInline;
exports.default = _default;